export const Label = {
  ml: '3px',
  color: '#6c6c6c',
}

export const EditInput = {
  borderRadius: '11px',
}
